export enum ShipmentNominationRole {
    SENDER = 'SENDER',
    RECEIVER = 'RECEIVER',
    WATCHER = 'WATCHER'
}
